import React from 'react';

import Header from './partials/Header';


import PersonalisedRoutine from './result/PersonalisedRoutine';
import Brands from './result/Brands';
import Reviews from './result/Reviews';
import ResultSidebar from './result/ResultSidebar';
import ReviewBar from './result/ReviewBar';
import Popup from './result/Popup';


import Footer from './partials/Footer';

function Result() {
  return (
    <div className="result">
        <Header/>
            {/* <ReviewBar/>
            <Popup/>*/}
            <div className="result__content">
                <div className="result__leftbar">
                    <div className="pl-lg-3 pl-lg-5 pr-lg-3 pr-lg-5">
                        <PersonalisedRoutine />
                        <div className="padding15">
                            <Brands />
                        </div>
                    </div>
                    <div className="reviews_sec">
                        <div className="pl-lg-3 pl-lg-5 pr-lg-3 pr-lg-5">
                            <div className="padding15">
                                <div className="website__customer">
                                    <h1>Love from Users</h1>
                                    <img className="mw-100" src="/images/website-customer.png" />
                                    <h3>See revews from users with same skin profile as yours</h3>
                                </div>
                                <Reviews />
                            </div>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
                <ResultSidebar />
                <div className="clearfix"></div>
            </div>
        <Footer/>
    </div>
  );
}

export default Result;
